import { Dispatch } from 'react';
import { AppInitAction, AppInitAsyncActions } from '../actions';
import { AppInitState } from '../types';

export const createAppInitMiddleware = (
  asyncActions: AppInitAsyncActions,
  getState: () => AppInitState
) => {
  return (next: Dispatch<AppInitAction>) => (action: AppInitAction) => {
    // Appeler d'abord le reducer pour mettre à jour l'état
    next(action);

    if (process.env.NODE_ENV === 'development') {
      // console.log('[AppInit Action]', action);
    }

    if (action.type === "SWITCH_ORGANIZATION" || action.type === "SET_ORGANIZATION_DATA") {
      document.documentElement.style.setProperty('--primary-color', action.payload.theme.primaryColor || '#51a0aa');
      document.documentElement.style.setProperty('--secondary-color', action.payload.theme.secondaryColor || '#ec7033');
    }

    return action;
  };
};
